/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/TypeAndDuration/Content/TemplateSelect/Content/ContentClick/Option",
  closePopover
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let appointmentOverlayAppointmentTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'appointment_type_id',
})
let itemIdValueData = fromData.useDataValue({ viewPath,
context: 'item',
path: 'id',
})
let aggregateData = fromAggregate.equals(appointmentOverlayAppointmentTypeIdValueData, itemIdValueData)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  closePopover,
  isHovered
  
})
let itemColorIdComputedValueData = fromData.useDataFormat({ viewPath,
context: 'item',
path: 'color_id_computed',
format: fromFormat.appointmentTypeColor,
})
let itemNameValueData = fromData.useDataValue({ viewPath,
context: 'item',
path: 'name',
})
  return (<React.Fragment
>
<button
  data-testid="Option.Horizontal"
  data-view-path={viewPath}
 closePopover={closePopover}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-6-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-7-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-8-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--g-10-Z2h7tiu': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--bc-1-Z2h7tiu': isHovered ? dtColorsNeutral200 : aggregateData ? dtColorsNeutral200 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Option.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z2h7tiu': itemColorIdComputedValueData,'--h-11-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--w-12-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--ml-13-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textOverflow="none"
 overflowX="visible"
 data="item.name"
 text={itemNameValueData}
/>
</button>
{children}
</React.Fragment>)
}